module.exports = __webpack_public_path__ + "img/roundedarw.fb5d653b.svg";